module.exports = __webpack_public_path__ + "static/img/mechanism-1.b667ca53.png";